/**
 * Created by cd01 on 2017/8/11.
 */
{
    angular.module('interfaceModule')
        .controller('PartnerController',PartnerController)
    PartnerController.$inject = ['$scope',"$state",'$http','$stateParams','utils.constant','alertControl','utils.platform','$timeout','utils.common','requestHandler','ModalWindow','utils.currentUser','request.order'];
    function PartnerController($scope,$state,$http,$stateParams,constant,alertControl,platform,$timeout,common,requestHandler,ModalWindow,currentUser,orderRequest){
        let vm = this;

        let collect = {
            'activate': activate,
            'clickTab': clickTab,   //点击导航栏
            'clickTabItem':'终端机异常',    //点击选择导航界面。
            'timer':null,
            'checkInterval':8000,

            'getMachineInfo':getMachineInfo,
            'choseErro': choseErro,
            'getCurMonTerCountInfo':getCurMonTerCountInfo,

            'userid':null,
            'terminalInfo':null,     //终端机信息集
            'statisticsYear': null,     //统计年份
            'terminalErroInfo':[],    //错误的终端机（填表要进行筛选）
            'printerErroInfo': [],    //错误的打印机 （填表要进行筛选）
            'printerErroNull':false,
            'terminalErroNull':false,

            'history': history,
            'PHMonCountiInfo': null,    //月统计历史，
            'CmonthParCountInfo':null,  //当前月加盟商月统计信息
            'CmonthTerCountInfo':null,  //当前月终端机月统计信息
            'THMonCountiInfo': null,    //特定终端机月统计历史

            //表格
            'PcurMonStatistical':true,
            'PhisMonStatistical': false,
            'TcurMonStatistical': true,
            'ThisMonStatistical': false,

            'historyCountYear': null,  //历史月统计的年份
            'PinputYear':null,    //年份：输入年份查询加盟商营业额历史月统计
            'PinputYear1': null,  //年份：查询加盟商历史特定月月统计
            'PinputMonth1': null,  //月份：查询加盟商历史特定月月统计

            'TinputYear': null,   //年份：输入年份查询终端机历史月统计
            'TinputYear1': null , //年份：查询终端机历史特定月月统计
            'TinputMonth1': null,  //月份：查询终端机历史特定月月统计
            'TinputMachineid': null,   //终端机id： 查询该终端机历史月统计

            'goBackTable': goBackTable,   //返回上一张表格

            'terCurMonth': null,    //终端机统计当前月份
            'terCurYear' : null,    //终端机统计当前年份
            'terCurDay'   :null,    //当前日期
            'partCurMonth': null,   //加盟商营业额统计当前月份
            'partCurYear': null,   // 加盟商营业额统计当前年份

            'addActive': false,
            'machinestatus': null,//终端机打印信息
            'printAmount ':null, //终端机打印量
            'consumptiveMaterial':null,//耗材
            'allPrintData':null,//所有打印数据
            'getTargetPrint' : getTargetPrint,//查询指定终端机打印或总数据
            'isAllSelected' : true,//默认全选
            'selectAll': selectAll,//点击全选
            'isAllPrint':false,//是否显示所有打印数据
            'getPrintData':getPrintData,//获取打印数据
            'clickItem' : clickItem,//单项点击
            'getMachineSupply':getMachineSupply,//获取指定终端机耗材页面
            'orderinfos':null,
            'orderinfo':null,//加盟商查询订单返回订单信息
            'getTargetOrder':getTargetOrder,//查询订单
            'timestart':null,
            'timeend':null,
            'querytype':'2',
            "day_paymethod": 'all',
            'machineid':null,
            'pagecounts':1,//总页数
            'currPage':1,//当前页
            'goPage':goPage,//上一页 下一页
            'goTargetPage':goTargetPage,//跳转指定页
            'gotoPage':1,
            'singlePageOrder':8,
            'all_mount':0,//总计
            'order_time':null,//查询时间年月日
            'queryTargetDayOrder':queryTargetDayOrder,//查询指定日的订单
            'partnerDayInfo':null,
            'queryorderid':null,

            'day_printnum':0,//日所有终端机 打印总订单数
            'day_successprintnum':0,//日所有终端机 成功打印订单数
            'day_refundnum':0,//日所有终端机 打印退款订单数
            'day_successpapernum':0,//日所有终端机 成功打印纸张数
            'day_A3':0,//日所有终端机 A3纸
            'day_A4':0,//日所有终端机 A4纸
            'day_colorpaperA4':0,//日所有终端机 A4彩纸
            'day_printamount':0,//日所有终端机 打印营业额
            'day_refund':0,//日所有终端机 退款
            'day_countamount':0,//日所有终端机 结算营业额

            'month_printnum':0,//月所有终端机 打印总订单数
            'month_successprintnum':0,//月所有终端机 成功打印订单数
            'month_refundnum':0,//月所有终端机 打印退款订单数
            'month_successpapernum':0,//月所有终端机 成功打印纸张数
            'month_A3':0,//月所有终端机 A3纸
            'month_A4':0,//月所有终端机 A4纸
            'month_colorpaperA4':0,//月所有终端机 A4彩纸
            'month_printamount':0,//月所有终端机 打印营业额
            'month_refund':0,//月所有终端机 退款
            'month_countamount':0,//月所有终端机 结算营业额

        };

        let tabItem = {
            'tab0': '终端机异常',
            'tab1': '终端机信息',
            'tab2': '营业额统计',
            'tab3': '终端机统计',
            'tab4': '终端机打印量',
            'tab5': '终端机耗材',
            'tab6': '订单查询'
        }

        vm.collect = collect;
        vm.tabItem = tabItem;

        activate();

        function activate(){
            console.log('进入加盟商页面');
            collect.userid = $stateParams.userId;
            var date = new Date();
            collect.statisticsYear = date.getFullYear();
            var year = date.getFullYear();
            var month = date.getMonth()+1;
            var day = date.getDate();
            var hour = date.getHours();
            var minute = date.getMinutes();
            var second = date.getSeconds();
            console.log('时间：',year +''+ month+'' + day +'' + hour+'' + minute+'' + second);
            //终端机统计当前时间：
            collect.terCurYear = year;
            collect.terCurMonth = month;
            collect.terCurDay = day;
            collect.TinputYear1 = year;
            collect.TinputMonth1 = month;

            collect.order_time = year+'-'+month+'-'+day;

            //加盟商统计当前时间
            collect.partCurYear = year;
            //查询年份
            //collect.PinputYear = year;
            //获取终端机信息
            getMachineInfo();
            $scope.$on("$destroy", function(e) {
                console.log(collect.timer);
                $timeout.cancel(collect.timer);

            })



        };
        //点击导航栏
        function clickTab(item,$index){
            console.log('item', item);
            console.log($index);
            $('#tab').find('li').removeClass('active');
            $('#tab').find('li').eq($index).addClass('active');
            collect.clickTabItem = item;
            if($index == 0){

            }else if($index == 1){
                //getMachineInfo();

            }else if($index == 2){
                if (!collect.historyCountYear){
                    var Hdate = new Date();
                    collect.historyCountYear = Hdate.getFullYear();
                }
                if(collect.CmonthParCountInfo){

                }else{
                    var _data = [{
                        'querytype': '2',
                        'userid': $stateParams.userId,
                        // 'userid': '15575952384'
                    }];
                    console.log('要传的数据',_data);
                    let params = "partnercurrinfo=" + JSON.stringify(_data);
                    requestHandler.simpleRequest(constant.action.partnercurrinfo, params,
                        function(responce){
                            console.log('加盟商当前月统计', responce);
                            if(responce.data[0].result == 1){
                                collect.CmonthParCountInfo =  responce.data[0].partnerinfo;

                                // console.log('填表信息', collect.CmonthParCountInfo);
                            }else if(responce.data[0].result == 0){
                                console.log("没有打印数据信息")
                            }
                        },
                    )
                    queryTargetDayOrder(1);
                }
            }else if($index == 3){
                if(collect.CmonthTerCountInfo){

                }else{
                    getCurMonTerCountInfo();
                }

            }else if($index == 4){
                collect.isAllPrint = false;
                var _data = [{
                    'querytype': '1',
                    'userid': $stateParams.userId,
                    //'userid': '15575952384',
                    'machineid':[]
                }];
                console.log('要传的数据',_data);
                let params = "machinestatus=" + JSON.stringify(_data);
                collect.getPrintData(params);
            }else if($index == 5){
                collect.isAllPrint = false;
                var _data = [{
                    'querytype': '2',
                    'userid': $stateParams.userId,
                    //'userid': '15575952384',
                    'machineid':[]
                }];
                console.log('要传的数据',_data);
                let params = "machinestatus=" + JSON.stringify(_data);
                collect.getPrintData(params);
            }else if($index == 6){
                $(".query_loading").addClass("active");
                collect.orderinfo = null;
                collect.timestart =collect.terCurYear+'-'+collect.terCurMonth+'-'+collect.terCurDay;
                collect.timeend = collect.terCurYear+'-'+collect.terCurMonth+'-'+collect.terCurDay;
                collect.machineid = null;
                collect.pagecounts = 1;
                collect.currPage = 1;
                collect.gotoPage = 1;
                var _data = [{
                    'querytype': '2',
                    'userid': $stateParams.userId,
                    //'userid': '15575952384',
                    'machineid':'',
                    'timestart':collect.timestart,
                    'timeend':collect.timeend,
                    //'ordertype':collect.ordertype
                    /*'timestart':'2017-7-1',
                    'timeend':'2017-11-15',*/
                }];
                console.log('要传的数据',_data);
                let params = "partnerordersquery=" + JSON.stringify(_data);
                requestHandler.simpleRequest(constant.action.partnerordersquery, params,
                function (response) {
                    $(".query_loading").removeClass("active");
                    collect.all_mount=0;
                    if(response.data[0].result == 1){
                        $(".noFilterTips").removeClass("active");
                        console.log("查询到的订单信息列表：",response);
                        //collect.orderinfos = response.data[0].orderinfo;
                        var singlePageOrder = parseInt(collect.singlePageOrder),
                            orders = response.data[0].orderinfo,
                            pagecounts = Math.ceil(orders.length/singlePageOrder),
                            order = [],
                            amount=0;
                        collect.pagecounts = pagecounts;
                        console.log("长度：",orders.length);
                        console.log("总页数：",pagecounts);
                        for(var i = 0;i<orders.length;i+=singlePageOrder){
                            order.push(orders.slice(i,i+singlePageOrder))
                        }
                        for(var j=0;j<orders.length;j++){
                            amount = amount+parseFloat(orders[j].amount);
                        }
                        collect.all_mount=amount.toFixed(2);
                        console.log("分割后",order);
                        collect.orderinfo = order;
                    }else{
                        $(".noFilterTips").addClass("active");
                        console.log("没有相关订单信息。");
                    }
                })
            }

        }
        //选择
        function selectAll(type) {
            //type为类型 0 打印量 1耗材 2打印和耗材
            if(collect.isAllSelected){
                collect.isAllSelected = false;
                    angular.forEach(collect.machinestatus,function(item,index){
                        item.isSelected = false;
                    });

            }else{
                collect.isAllSelected = true;
                    angular.forEach(collect.machinestatus,function(item,index){
                        item.isSelected = true;
                    });

            }
        }
        //查询
        function getTargetPrint(queryType) {
            collect.isAllSelected = true;
            var machineid = [];
            let params = null;
            collect.isAllPrint = false;
            angular.forEach(collect.machinestatus,function(item,index){
                console.log("状态：",item.isSelected);
                if(item.isSelected){
                    machineid.push(item.machineid);
                }
            });
            if(queryType==3){
                vm.collect.isAllPrint = true;
                var _data = [{
                    'querytype': queryType,
                    'userid': $stateParams.userId,
                    //'userid': '15575952384',
                    'machineid':machineid
                }];
            }else{
                vm.collect.isAllPrint = false;
                var _data = [{
                    'querytype': queryType,
                    'userid': $stateParams.userId,
                    //'userid': '15575952384',
                    'machineid':machineid
                }];
            }

            console.log('要传的数据',_data);
            params = "machinestatus=" + JSON.stringify(_data);
            getPrintData(params);
        }
        //获取数据
        function getPrintData(params) {
                requestHandler.simpleRequest(constant.action.machinestatus, params,
                    function(responce){
                        console.log('加盟商当前打印信息', responce);
                        if(responce.data[0].result == 1){
                            collect.machinestatus  =  responce.data[0].machinestatus ;
                            angular.forEach(collect.machinestatus,function(item,index){
                                item.isSelected = true;//默认选中
                            });
                            console.log('填表信息', collect.machinestatus );
                        }else if(responce.data[0].result == 0){
                            console.log("返回出错")
                        }
                    },
                )

        }
        //单个点击
        function clickItem($event,value){
            if(value == true){
                value = false;
            }else{
                value = true;
                collect.isAllSelected = false;
            }
        }
        //获取指定终端机的耗材报表页
        function getMachineSupply($event,item){
            var timer;
            if(timer){clearInterval(timer)}
            var _data1 = [{
                'userid': $stateParams.userId,
                'machineid':item.machineid,
                'operationtype':1
            }];
            console.log("获取报表传参1：",_data1);
            let params1 = "machineinfo=" + JSON.stringify(_data1);
            var newTab = window.open('about:blank');//防止打开新窗口时拦截
            requestHandler.simpleRequest(constant.action.supplystatusget, params1,
                function (response) {
                console.log("获取报表返回1：",response);
                    if(response.data[0].result == 1){
                        timer = setInterval(getMachineHtml,1500)
                    }else if(response.data[0].result == 0){
                        common.alert("查看失败，请重新尝试")
                    }
                });
            function getMachineHtml(){

                var _data2 = [{
                    'userid': $stateParams.userId,
                    'machineid':item.machineid,
                    'operationtype':2
                }];
                console.log("获取报表传参2：",_data2);
                let params2 = "machineinfo=" + JSON.stringify(_data2);
                requestHandler.simpleRequest(constant.action.supplystatusget, params2,
                    function (response) {
                        console.log("获取报表返回2：",response);
                        if(response.data[0].result == 1){
                            //查询成功，跳转至新的标签页
                            clearInterval(timer);
                            var url = response.data[0].filename;
                            newTab.location.href='http://www.my51y.com/xyprint/machineupload/'+url;
                        }else{
                            //common.alert("终端机可能未上传完毕，请重新尝试")
                        }
                    })
            }
        }
        function goPage(currPage,type) {
            //type 0 上一页 1 下一页
            if(type==0 && currPage!=1){
                collect.currPage=parseInt(collect.currPage)-1;
            }else if(type == 1 && currPage!=collect.pagecounts){
                collect.currPage=parseInt(collect.currPage)+1;
            }
        }
        function goTargetPage(pageNum) {
            if(pageNum>collect.pagecounts){
                common.alert("最大页数为"+collect.pagecounts+"页")
            }else{
                collect.currPage = pageNum;
            }
        }
        function getTargetOrder() {
            collect.orderinfo = null;
            collect.pagecounts = 1;
            collect.currPage = 1;
            collect.gotoPage = 1;
            $(".query_loading").addClass("active");
            var _data;
            if(collect.queryorderid && collect.queryorderid!=""){
                _data = [{
                    'querytype': 1,
                    'userid': $stateParams.userId,
                    'orderid':collect.queryorderid
                }]
            }else{
                _data = [{
                    'querytype': collect.querytype,
                    'userid': $stateParams.userId,
                    //'userid': '15575952384',
                    'machineid':collect.machineid,
                    'timestart':collect.timestart,
                    'timeend':collect.timeend,
                    //'ordertype':collect.ordertype
                }];
            }
            console.log('要传的数据',_data);
            let params = "partnerordersquery=" + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.partnerordersquery, params,
                function (response) {
                    $(".query_loading").removeClass("active");
                    console.log("查询到的订单信息列表：",response);
                    collect.all_mount=0;
                    if(response.data[0].result == 1){
                        $(".noFilterTips").removeClass("active");
                        collect.orderinfos = response.data[0].orderinfo;
                        var singlePageOrder = parseInt(collect.singlePageOrder),
                            orders = response.data[0].orderinfo,
                            pagecounts = Math.ceil(orders.length/singlePageOrder),
                            order = [],
                            amount=0;
                        collect.pagecounts = pagecounts;
                        console.log("长度：",orders.length);
                        console.log("总页数：",pagecounts);
                        for(var i = 0;i<orders.length;i+=singlePageOrder){
                            order.push(orders.slice(i,i+singlePageOrder));

                        }
                        for(var j=0;j<orders.length;j++){
                            /**
                             *判断印张数 单面打印每张纸印张数为 1
                             *双面打印每张纸印张数为2（只打一面纸也算2印张数）
                             * 普通打印 单面打印印张数为 单份文档页数*文档份数
                             *         双面打印如果单份文档数为奇数 印张数=（单份文档页数+1）*文档份数
                             *         双面打印如果单份文档数为偶数 印张数= 单份文档页数*文档份数
                             * 论文打印 如果 单份文档页数-单面打印份数 为奇数 印张数=（单面打印页数*2+（单份文档页数-单面打印份数+1））*文档份数
                             *         如果 单份文档页数-单面打印份数 为偶数 印张数=（单面打印页数*2+（单份文档页数-单面打印份数））*文档份数
                             */
                            amount = amount+parseFloat(orders[j].amount);
                            /*var numtype = orders[j].docpages%2;
                            orders[j].docpages=orders[j].docpages*1;
                            orders[j].singlepagenum=orders[j].singlepagenum*1;
                            if(orders[j].printtype==0){
                                if(orders[j].printmode==1){
                                    orders[j].printnums=orders[j].docpages*orders[j].printnum;
                                }else if(orders[j].printmode==2){
                                    orders[j].printnums=numtype==0?orders[j].docpages*orders[j].printnum:(orders[j].docpages+1)*orders[j].printnum;
                                }
                            }else if(orders[j].printtype==1){
                                orders[j].printnums=orders[j].singlepagenum%2==0?(orders[j].singlepagenum+orders[j].docpages)*orders[j].printnum:(orders[j].singlepagenum+orders[j].docpages+1)*orders[j].printnum;
                            }*/
                        }
                        collect.all_mount=amount.toFixed(2);
                        console.log("分割后",order);
                        collect.orderinfo = order;
                    }else{
                        $(".noFilterTips").addClass("active");
                        console.log("没有相关订单信息。");
                    }
                })
        }
        //获取终端机信息
        function getMachineInfo(){
            collect.terminalInfo = null;
            var _data = [{
                'userid': collect.userid
                // 'userid':'15575952384'
            }];
           // console.log('要传的参数', _data);
            let params = "partnermachine=" + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.partnermachineinfo, params,
                function(responce){
                    if(!collect.addActive){
                        $('#tab').find('li').eq(0).addClass('active');
                        collect.addActive = true;
                    }

                    console.log('返回的加盟商终端机信息',responce);
                    if(responce.data[0].result == 1){

                        collect.terminalInfo = responce.data[0].partnermachine;
                        var terminalArr = [];
                        for(var i=0; i<collect.terminalInfo.length; i++){
                            var terminal = {};
                            //判断打印机类型
                            var a = collect.terminalInfo[i].bwprinter + collect.terminalInfo[i].colorprinter;
                            //console.log('a的值',a);
                            switch (a){
                                case '00':
                                    collect.terminalInfo[i].printertype = '';
                                    delete collect.terminalInfo[i].bwprinter;
                                    delete collect.terminalInfo[i].colorprinter;
                                    break;

                                case '01':
                                    collect.terminalInfo[i].printertype = '彩色';
                                    delete collect.terminalInfo[i].bwprinter;
                                    delete collect.terminalInfo[i].colorprinter;
                                    break;

                                case '10':
                                    collect.terminalInfo[i].printertype = '黑白';
                                    delete collect.terminalInfo[i].bwprinter;
                                    delete collect.terminalInfo[i].colorprinter;
                                    break;

                                case '11':
                                    collect.terminalInfo[i].printertype = '黑白/彩色';
                                    delete collect.terminalInfo[i].bwprinter;
                                    delete collect.terminalInfo[i].colorprinter;
                                    break;

                                default:
                                    collect.terminalInfo[i].printertype = '';
                                    delete collect.terminalInfo[i].bwprinter;
                                    delete collect.terminalInfo[i].colorprinter;
                            };

                            //页面尺寸判断：
                            var b = collect.terminalInfo[i].printerpagetype;
                            var c = parseInt(b,2);
                            switch (c){
                                case 0:
                                    collect.terminalInfo[i].printerpagetype = '';
                                    break;

                                case 1:
                                    collect.terminalInfo[i].printerpagetype = 'A4';
                                    break;

                                case 2:
                                    collect.terminalInfo[i].printerpagetype = 'A3';
                                    break;

                                case 3:
                                    collect.terminalInfo[i].printerpagetype = 'A3/A4';
                                    break;

                                default:
                                    collect.terminalInfo[i].printerpagetype = '';
                            }
                        };
                        //console.log('填表的信息', collect.terminalInfo);
                        //collect.printerErroInfo = collect.terminalInfo;       //  ==> BUG:这种赋值方法把两个参数双向绑定了。作用域相同
                        //collect.terminalErroInfo = collect.terminalInfo;

                        // console.log('打印机的信息', printerErroInfo);
                        // console.log('终端机的信息', terminalErroInfo);

                        // angular.copy（）==》只拿数据你，不拿连接地址; 解决了赋值时的双向绑定
                        var printerErroInfo = angular.copy(collect.terminalInfo);
                        var terminalErroInfo =angular.copy( collect.terminalInfo);
                        choseErro(printerErroInfo,terminalErroInfo);

                    }
                },
                function(responce){

                }
            );


        }

        //筛选出错的终端机和打印机
        function choseErro(printerErroInfo,terminalErroInfo){
            //console.log('打印机信息',printerErroInfo);
            //console.log('终端机信息',terminalErroInfo);
            collect.printerErroInfo = [];
            collect.terminalErroInfo = [];
            //筛选出错误的打印机：
            for(var i=0; i<printerErroInfo.length; i++){
                if(printerErroInfo[i].comments.indexOf('normal') == -1){
                    //delete collect.printerErroInfo[i];
                    //printerErroInfo.splice(i,1);
                     //printerErroInfo.remove(printerErroInfo[i]);
                    collect.printerErroInfo.push(printerErroInfo[i]);
                }
            };
            //筛选出错误的终端机机：
            var _hours = new Date().getHours();
            var _min = new Date().getMinutes();
            for(var i=0; i<terminalErroInfo.length; i++){

                if((_hours - terminalErroInfo[i].reporttime.substr(11).substring(0,2) != 0) || (_min - terminalErroInfo[i].reporttime.substr(11).substring(3,5) > 5) || (_min - terminalErroInfo[i].reporttime.substr(11).substring(3,5) < -5)){
                    collect.terminalErroInfo.push(terminalErroInfo[i]);
                }

            };
            //这时才进行赋值
            //collect.printerErroInfo = printerErroInfo;
            //collect.terminalErroInfo = terminalErroInfo;
            console.log('筛选出的打印机',collect.printerErroInfo);
            console.log('筛选出的终端机',collect.terminalErroInfo);
            //console.log('原来的填表信息', collect.terminalInfo);

            if(collect.printerErroInfo.length > 0){
                collect.printerErroNull = true;
            }else{
                collect.printerErroNull = false;
            };

            if(collect.terminalErroInfo.length > 0){
                collect.terminalErroNull = true;
            }else{
                collect.terminalErroNull = false;
            };
            //定时检测；
            collect.timer=$timeout(collect.getMachineInfo,30000);   //==>BUG: 在这里延时器里的函数只能写 collect.getMachineInfo ，不能写 getMachineInfo 或 getMachineInfo()  。

        }

        //终端机统计：获取当前月不同终端机统计信息
        function getCurMonTerCountInfo(){
            var _data = [{
                'querytype': '3',
                'userid': $stateParams.userId,
            }];
            console.log('要传的数据',_data);
            let params = "partnercurrinfo=" + JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.partnercurrinfo, params,
                function(responce){
                    console.log('终端机当前月统计22', responce);
                    if(responce.data[0].result == 1){
                        collect.CmonthTerCountInfo =  responce.data[0].partnerinfo;

                    }else if(responce.data[0].result == 0){
                        common.alert("当前月还没有统计信息");
                    }
                },
                function(responce){
                    common.alert("系统出错");

                }
            )
        }

        //历史月统计：
        function history(num,item){
            var _date = new Date();
            // var _year = _date.getFullYear();
            if(num == 1){
                if (collect.historyCountYear == '' || collect.historyCountYear == null){
                    common.alert('请输入要查询账单的年份');

                    return false;
                }
                if(collect.historyCountYear > collect.terCurYear){
                    common.alert('查询年份错误');
                    return false;
                }
                collect.PinputYear = null;
                var _data = {
                    'querytype': '2',      //  加盟商月统计
                    'year' : collect.historyCountYear,
                    'userid': $stateParams.userId
                };

                console.log('要传的参数', _data);
                let params = "partnerinfo=" + JSON.stringify([_data]);
                requestHandler.simpleRequest(constant.action.partnerprintcount, params,
                    function(responce){
                        console.log('历史信息：', responce);
                        if(responce.data[0].result == 1){
                            if(_data.querytype == 2){
                                // collect.PinputYear = responce.data[0].countyear;
                                collect.PHMonCountiInfo =  responce.data[0].partnerinfo;

                                collect.PcurMonStatistical = false;  //隐藏表格
                                collect.PhisMonStatistical = true;
                            }
                        }else if(responce.data[0].result == 0){
                            console.log("返回历史账单出错");
                            common.alert('暂时还没有账单数据！');
                        }
                    },
                    function(responce){
                        console.log('访问错误', responce);
                        common.alert('系统错误，请重新查询！');
                    }
                );
            }else if(num == 2){   //查询某台终端机某一年的所有月结账单。
                var _year = _date.getFullYear();
                if(item){
                    collect.TinputYear = null;
                    collect.TinputMachineid = null;
                    var _data = {
                        'querytype': '3',      //  终端机月统计
                        'year' : item.year,
                        'machineid': item.machineid,
                        'userid': $stateParams.userId
                    };
                }else{
                    if(collect.TinputYear == '' || collect.TinputYear == null){
                        common.alert('请输入要查询的账单年份');
                        return false;
                    }
                    if(collect.TinputMachineid == '' || collect.TinputMachineid == null){
                        common.alert('请输入要查询的终端机');
                        return false;
                    }
                    if(collect.TinputYear > collect.terCurYear){
                        common.alert('查询年份错误！');
                        return false;
                    }

                    var _data = {
                        'querytype': '3',      //  终端机月统计
                        'year' : collect.TinputYear,
                        'machineid': collect.TinputMachineid,
                        'userid': $stateParams.userId
                    }
                }

                console.log('要传的参数', _data);
                let params = "partnerinfo=" + JSON.stringify([_data]);
                requestHandler.simpleRequest(constant.action.partnerprintcount, params,
                    function(responce){
                        console.log('历史信息：', responce);
                        if(responce.data[0].result == 1){
                            collect.THMonCountiInfo =  responce.data[0].partnerinfo;
                            collect.TcurMonStatistical = false;
                            collect.ThisMonStatistical = true;

                        }else if(responce.data[0].result == 0){
                            common.alert(_data.year + '年暂时还没有 ' + _data.machineid + '号终端机的月结账单信息');
                        }
                    },
                    function(responce){
                        console.log('访问错误', responce);
                        common.alert('系统错误！');
                    }
                );
            } else if(num == 3){            //查某一年加盟商的月结账单
                if (collect.PinputYear == '' || collect.PinputYear == null){
                    common.alert('请输入查询账单的年份！');
                    return false;
                }
                if(collect.PinputYear > collect.terCurYear){
                    common.alert('查询年份错误！');
                    return false;
                }
                var _year = _date.getFullYear();
                collect.PhisMonStatistical = true;
                // collect.PHMonCountiInfo = null;
                var _data = {
                    'querytype': '2',
                    'year' : collect.PinputYear,
                    'userid': $stateParams.userId
                };

                console.log('要传的参数', _data);
                let params = "partnerinfo=" + JSON.stringify([_data]);
                requestHandler.simpleRequest(constant.action.partnerprintcount, params,
                    function(responce){
                        console.log('历史信息：', responce);
                        if(responce.data[0].result == 1){
                            // collect.PinputYear = responce.data[0].countyear;
                            collect.PHMonCountiInfo =  responce.data[0].partnerinfo;

                        }else if(responce.data[0].result == 0){
                            //没有账单数据
                            common.alert(collect.PinputYear + '年暂时还没有账单数据！');
                        }
                    },
                    function(responce){
                        console.log('访问错误', responce);
                        common.alert('系统出错，请重新查询！');
                    }
                );
            }else if(num = 4){
                var _year = _date.getFullYear();
                if(collect.TinputYear1 > collect.terCurYear){
                    common.alert('查询年份错误！');
                    return false;
                }
                if (collect.TinputYear1 == collect.terCurYear && collect.TinputMonth1 > collect.terCurMonth){
                    common.alert('查询月份错误！');
                    return false;
                }

                if(collect.TinputYear1 == collect.terCurYear  && collect.TinputMonth1 == collect.terCurMonth ){
                    console.log('应该用当前月函数和接口');
                    getCurMonTerCountInfo();
                }else{
                    collect.month_printnum = 0;
                    collect.month_successprintnum = 0;
                    collect.month_refundnum = 0;
                    collect.month_successpapernum = 0;

                    collect.month_A3 = 0;
                    collect.month_A4 = 0;
                    collect.month_colorpaperA4 = 0;
                    collect.month_printamount = 0;

                    collect.month_refund = 0;
                    collect.month_countamount = 0;
                    var _data = {
                        'querytype': '4',
                        'year': collect.TinputYear1,
                        'month': collect.TinputMonth1,
                        'userid': $stateParams.userId,
                    };
                    console.log('要传的数据',_data);
                    let params = "partnerinfo=" + JSON.stringify([_data]);

                    requestHandler.simpleRequest(constant.action.partnerprintcount, params,
                        function(responce){
                            console.log('终端机历史月统计信息', responce);
                            if(responce.data[0].result == 1){
                                collect.CmonthTerCountInfo =  responce.data[0].partnerinfo;

                            }else if(responce.data[0].result == 0){
                                console.log("没找到相关记录");
                                common.alert(collect.TinputYear1 + '年' + collect.TinputMonth1 + '月 没有终端机月结账单信息');
                            }
                        },
                        function(responce){
                            common.alert('系统出错！');
                        }
                    )
                }

            }
        }

        //点击返回上一张表
        function goBackTable(num){
            if(num == 1){
                collect.PhisMonStatistical = false;
                collect.PcurMonStatistical = true;
            }else if(num == 2){
                collect.TcurMonStatistical = true;
                collect.ThisMonStatistical = false;
            }
        }
        function queryTargetDayOrder(item) {
            collect.day_printnum = 0;
            //collect.day_successprintnum = collect.day_successprintnum+collect.partnerDayInfo[i].ordersuccessnum*1;
            collect.day_refundnum = 0;
            collect.day_successpapernum = 0;
            collect.day_A3 = 0;
            collect.day_A4 = 0;
            collect.day_colorpaperA4 = 0;
            collect.day_printamount = 0;
            collect.day_refund = 0;
            collect.day_countamount = 0;
            if(collect.order_time){
                if(item == 2){
                    var date = new Date(),
                    year = date.getFullYear(),
                    month = date.getMonth()+1,
                    day = date.getDate();
                    collect.partnerDayInfo = null;
                    collect.order_time =year+'-'+month+'-'+day;
                    console.log('collect.order_time'+collect.order_time);
                }
                var _data = {
                    'date': collect.order_time,
                    'userid': $stateParams.userId,
                    'paymethod': collect.day_paymethod

                };
                console.log('要传的数据',_data);
                let params = "partnerdayinfo=" + JSON.stringify([_data]);
                requestHandler.simpleRequest(constant.action.partnerdayinfo, params,
                    function(response){
                        console.log("查询日营业统计返回",response);
                        if(response.data[0].result == 1){
                            collect.partnerDayInfo = response.data[0].partnercurrinfo;
                            for(var i in collect.partnerDayInfo){
                                //打印营业额
                                //collect.partnerDayInfo[i].printamount=(collect.partnerDayInfo[i].amount*1+collect.partnerDayInfo[i].refundamount*1).toFixed(2);
                                //退款
                               // collect.partnerDayInfo[i].allrefundamount = (collect.partnerDayInfo[i].refundamount*1+collect.partnerDayInfo[i].lastrefundamount*1).toFixed(2);
                                //结算营业额
                                collect.partnerDayInfo[i].countAmount = (parseFloat(collect.partnerDayInfo[i].print_amount_sum)-parseFloat(collect.partnerDayInfo[i].refund_amount_sum)).toFixed(2);

                                collect.day_printnum = collect.day_printnum+collect.partnerDayInfo[i].order_print_sum*1;
                                //collect.day_successprintnum = collect.day_successprintnum+collect.partnerDayInfo[i].ordersuccessnum*1;
                                collect.day_refundnum = collect.day_refundnum+collect.partnerDayInfo[i].order_refund_sum*1;
                                collect.day_successpapernum = collect.day_successpapernum+collect.partnerDayInfo[i].order_print_pages_sum*1;
                                collect.day_A3 = collect.day_A3+collect.partnerDayInfo[i].order_print_pages_a3_sum*1;
                                collect.day_A4 = collect.day_A4+collect.partnerDayInfo[i].order_print_pages_a4_bw_sum*1;
                                collect.day_colorpaperA4 = collect.day_colorpaperA4+collect.partnerDayInfo[i].order_print_pages_a4_color_sum*1;
                                collect.day_printamount = collect.day_printamount+collect.partnerDayInfo[i].print_amount_sum*1;
                                collect.day_refund = collect.day_refund+collect.partnerDayInfo[i].refund_amount_sum*1;
                                collect.day_countamount = collect.day_countamount+collect.partnerDayInfo[i].countAmount*1;

                            }
                            collect.day_printamount=collect.day_printamount.toFixed(2);
                            collect.day_refund=collect.day_refund.toFixed(2);
                            collect.day_countamount=collect.day_countamount.toFixed(2);

                        }
                        else if(response.data[0].result == 0){
                            console.log("查询日营业统计返回出错");
                        }
                    })
            }else{
                common.alert("请输入查询时间");
            }




        }

    }
}